// https://developer.rocket.chat/reference/api/livechat-api

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    RocketChat: Function | any;
  }
}

type TSetUserInfo = (__user: {
  nationalId?: string;
  displayName?: string;
  pk?: string;
  email?: string;
}) => void;

export type TRegisterChatScriptProps = {
  onError?: (__error: any) => void;
  onChatReady?: (__setUserInfo: TSetUserInfo) => void;
  onChatStarted?: () => void;
  onWidgetShown?: () => void;
  onWidgetHidden?: () => void;
  onMessage?: (__data: {
    isShown: boolean;
    totalUnread: number;
    lastMessageText: string;
  }) => void;
};

export const registerChatScript = ({
  onError,
  onChatReady,
  onChatStarted,
  onWidgetShown,
  onWidgetHidden,
  onMessage,
}: TRegisterChatScriptProps) => {
  const chatScriptId: string = '--chat-script';
  if (document.getElementById(chatScriptId)) return;
  const chatUrl = 'https://chatbot.emofid.com/livechat';

  window.RocketChat = (chat: Function) => window.RocketChat._.push(chat);
  window.RocketChat._ = [];
  window.RocketChat.url = chatUrl;

  const chatScript = document.createElement('script');
  chatScript.src = `${chatUrl}/rocketchat-livechat.min.js?_=${Date.now()}`;
  chatScript.id = chatScriptId;
  chatScript.defer = true;
  chatScript.onerror = (event, source, lineno, colno, error) => {
    console.log('chat@onLoadError', error);
    return onError?.(error);
  };
  const scripts = document.getElementsByTagName('script')?.[0];
  scripts?.parentNode?.insertBefore(chatScript, scripts);

  window.RocketChat(function () {
    try {
      const self = window?.RocketChat?.livechat;
      self.initialize({
        theme: { title: 'خوش آمدید', offlineTitle: 'سرویس در دسترس نمی‌باشد ' },
        language: 'fa',
        hideButton: true,
        allowMinimize: true,
      });

      self?.onChatReady?.(function () {
        const setUserInfo: TSetUserInfo = (user) => {
          self?.setCustomField?.('guid', user?.pk, true);
          self?.setGuestName?.(user?.displayName);
          self?.setGuestEmail?.(user?.email);
        };
        onChatReady?.(setUserInfo);
      });
      self?.onChatStarted?.(() => {
        onChatStarted?.();
      });
      self?.onWidgetShown?.(() => {
        self.isShown = true;
        onWidgetShown?.();
      });
      self?.onWidgetHidden?.(() => {
        self.isShown = false;
        onWidgetHidden?.();
      });
      self?.onMessage?.(({ totalUnread, lastMessageText }: any) => {
        onMessage?.({ isShown: self.isShown, totalUnread, lastMessageText });
      });
    } catch (error) {
      console.log('chat@error', error);
      onError?.(error);
    }
  });
};

export const restoreChatVisibility = () => {
  window?.RocketChat?.livechat?.restore?.();
};
